import React from "react";
import PageHeader from "../components/page-header";
import { Link } from "react-router-dom";
import ImageSlider from "../components/image-slider";

const ProductsActivityBookingEngine = () => {
  return (
    <div className="page-inside page-booking-engine">
      <PageHeader page="activity-booking-engine" />
      <div className="container">
        <div className="row mb-5">
          <div className="col-lg-6 text-center">
            <ImageSlider slider="ABS1" />
          </div>
          <div className="col-lg-6 text-justify">
            <p style={{ fontSize: "1.1rem", lineHeight: "30px" }}>
              Our Activity Booking Engine has served 100+ travel companies with seamless activity booking. Built on 24+ years of travel technology expertise, it's proof of our domain knowledge. Today, this proven capability is available as a standalone SaaS solution, managed service (we operate it), custom platform module (integrated into your stack), or API integration. Add modern activity management to your enterprise infrastructure without migration.
            </p>

            <Link to="/contact-us" className="btn btn-primary mt-3">
              Discuss Your Booking Engine Challenge
            </Link>
          </div>
        </div>
      </div>

      <div className="benefits-section-bg">
        <div className="container">
          <div className="row">
            <h2 className="text-center mt-5">
              Enterprise Activity Booking Technology
            </h2>
            <div className="col-lg-6">
              <ul className="list-unstyled p-0 m-0">
                <li>
                  <i className="material-icons"></i>Available on both web and
                  mobile (responsive and native app)
                </li>
                <li>
                  <i className="material-icons"></i>Supports multiple sales
                  channels - B2C, B2B, B2B2C, B2E and Corporate
                </li>
                <li>
                  <i className="material-icons"></i>Supports multiple languages
                  and currencies with real-time currency conversion
                </li>
                <li>
                  <i className="material-icons"></i>Aggregation of{" "}
                  <Link
                    to="/suppliers/sightseeing-api-integration"
                    className="text-decoration-none text-primary"
                  >
                    multiple activity XML feeds
                  </Link>{" "}
                  along with directly contracted inventory into a single search
                  interface
                </li>
                <li>
                  <i className="material-icons"></i>Multiple search filters and
                  sorting options including price, currency, activity name,
                  activity type
                </li>
                <li>
                  <i className="material-icons"></i>Ability to display activity
                  description, images, schedule, inclusions and exclusions,
                  terms and conditions
                </li>
                <li>
                  <i className="material-icons"></i>View activities on a map
                </li>
                <li>
                  <i className="material-icons"></i>Ability to add multiple
                  activities to a shopping cart and book them together
                </li>
                <li>
                  <i className="material-icons"></i>Ability to book activities
                  with flight(s) and hotels
                </li>
              </ul>
            </div>
            <div className="col-lg-6">
              <ul className="list-unstyled p-0 m-0">
                <li>
                  <i className="material-icons"></i>Ability to set up
                  activities, rates, availability, policies and other details in
                  the activity inventory management system
                </li>
                <li>
                  <i className="material-icons"></i>Ability to show activity
                  promotions and advertisements in search results
                </li>
                <li>
                  <i className="material-icons"></i>Automatic activity voucher
                  generation with your own branding
                </li>
                <li>
                  <i className="material-icons"></i>Ability to store frequent
                  co-traveler details to save time during booking
                </li>
                <li>
                  <i className="material-icons"></i>Login with Facebook and
                  Google
                </li>
                <li>
                  <i className="material-icons"></i>User-friendly interface for
                  centralized customer and booking management
                </li>
                <li>
                  <i className="material-icons"></i>Separate markups and
                  commission setup for B2C and B2B
                </li>
                <li>
                  <i className="material-icons"></i>Extensive booking reports
                  for decision making and accounting reconciliation
                </li>
                <li>
                  <i className="material-icons"></i>Auto cancellation of
                  unconfirmed bookings before the cancellation period starts
                </li>
                <li>
                  <i className="material-icons"></i>Ability to add activities to
                  wishlist and favourites
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsActivityBookingEngine;
